/**
 * 角色管理
 * **/

const roleApi = {
  //获取列表
  getList: '/Role/GetList',
  //获取信息
  getInfo: '/Role/GetInfo',
  //添加
  add: '/Role/Add',
  //修改
  edit: '/Role/Edit',
  //删除
  delete: '/Role/Del',
}

export default roleApi
